<template>
<div id="dvMap" style="width:100%;height:400px;"></div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
export default {
  name: 'googleMap',
  components: {},
  directives: {},
  props: ['id'],
  data() {
    return {
      date: 'abc',
      markersTemp: [{
          title: 'C',
          lat: '26.807',
          lng: '92.895',
          description: 'C'
        },
        {
          title: 'D',
          lat: '26.3508',
          lng: '92.7102',
          description: 'D'
        }
      ],
      markers: [{
          title: 'A',
          lat: '26.3489',
          lng: '92.6845',
          description: 'A'
        },
        {
          title: 'B',
          lat: '26.3546',
          lng: '92.6902',
          description: 'B'
        },
        {
          title: 'D',
          lat: '26.3508',
          lng: '92.7102',
          description: 'D'
        },

        {
          title: 'E',
          lat: '26.4285',
          lng: '92.8497',
          description: 'E'
        },
        {
          title: 'E',
          lat: '26.5486',
          lng: '92.9008',
          description: 'E'
        },
        {
          title: 'E',
          lat: '26.6567',
          lng: '92.7717',
          description: 'E'
        },
        {
          title: 'C',
          lat: '26.807',
          lng: '92.895',
          description: 'C'
        }
      ]
    }
  },
  computed: {},
  mounted () {
    this.getDate()
  },
  methods: {
    getDate: function () {
      var d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      this.date = [year, month, day].join('')
      var requestObj = {
        deliveryagentmasterid: 162,
        trackdate: this.date
      }
      var myPromiss = []
      myPromiss[0] = this.$http.post(
        `${CONSTANTS.API_URL}/DeliveryAgentTrackActivity`,
        requestObj
      )
      myPromiss[1] = this.$http.post(
        `${CONSTANTS.API_URL}/DeliveryAgentTrackLocation`,
        requestObj
      )
      Promise.all(myPromiss)
        .then(responseData => {
          if (responseData[0].data.returnmsg === 'successful') {
            this.markersTemp = responseData[0].data.returnvalue
          }
          if (responseData[1].data.returnmsg === 'successful') {
            this.markers = responseData[1].data.returnvalue
          }
          this.showMap()
        })
        .catch(error => {
          console.log('error')
        })
    },
    getData: function () {
      var link = 'http://localhost:3000/myfile'
      this.$http.get(link).then(
        function (response) {
          console.log(JSON.parse(response))
        },
        function (error) {
          console.log(error.statusText)
        }
      )
    },
    showMap: function () {
      var mapOptions = {
        center: new google.maps.LatLng(
          this.markers[0].lat,
          this.markers[0].lng
        ),
        zoom: 20,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      }
      var map = new google.maps.Map(
        document.getElementById('dvMap'),
        mapOptions
      )
      var infoWindow = new google.maps.InfoWindow()
      var lat_lng = new Array()
      var latlngbounds = new google.maps.LatLngBounds()
      for (var i = 0; i < this.markers.length; i++) {
        var data = this.markers[i]
        if (data.hasOwnProperty('lat') && data.hasOwnProperty('lng')) {
          var myLatlng = new google.maps.LatLng(data.lat, data.lng)
          lat_lng.push(myLatlng)
          var marker = new google.maps.Marker({
            position: myLatlng,
            map: map,
            title: data.title,
            icon: './assets/placeholder.png'
          })
          latlngbounds.extend(marker.position)
            (function(marker, data) {
              google.maps.event.addListener(marker, 'click', function (e) {
                infoWindow.setContent(data.description)
                infoWindow.open(map, marker)
              })
            })(marker, data)
        }
      }
      for (i = 0; i < this.markersTemp.length; i++) {
        var data = this.markersTemp[i]
        if (data.hasOwnProperty('lat') && data.hasOwnProperty('lng')) {
          var myLatlng = new google.maps.LatLng(data.lat, data.lng)
          var marker = new google.maps.Marker({
            position: myLatlng,
            map: map,
            title: data.title,
            icon: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
          })
          latlngbounds.extend(marker.position)
            (function (marker, data) {
              google.maps.event.addListener(marker, 'click', function (e) {
                infoWindow.setContent(data.description)
                infoWindow.open(map, marker)
              })
            })(marker, data)
        }
      }
      map.setZoom(12)
      map.setCenter(latlngbounds.getCenter())
      map.fitBounds(latlngbounds)
      var service = new google.maps.DirectionsService()
      for (i = 0; i < lat_lng.length; i++) {
        if (i + 1 < lat_lng.length) {
          var src = lat_lng[i]
          var des = lat_lng[i + 1]
          service.route({
              origin: src,
              destination: des,
              travelMode: google.maps.DirectionsTravelMode.DRIVING
            },
            function  (result, status) {
              if (status === google.maps.DirectionsStatus.OK) {
                var path = new google.maps.MVCArray()
                var poly = new google.maps.Polyline({
                  map: map,
                  strokeColor: '#4986E7'
                })
                poly.setPath(path)
                for (
                  var i = 0, len = result.routes[0].overview_path.length; i < len; i++
                ) {
                  path.push(result.routes[0].overview_path[i])
                }
              }
            }
          )
        }
      }
    }
  }
}
</script>
